export const GET_CURRENT_SHARE = "GET_CURRENT_SHARE";
export const REFRESH_CURRENT_SHARE = "REFRESH_CURRENT_SHARE";
export const RESET_CURRENT_SHARE = "RESET_CURRENT_SHARE";
export const SET_CURRENT_SHARE_REQUEST_STATUS = "SET_CURRENT_SHARE_REQUEST_STATUS";
